import { AssetsPage } from 'features/assets';

export const TechOperatorMainPage: React.FC = () => <AssetsPage />;
